export default __webpack_public_path__ + "static/media/CloudOverview300.08e01ff3.jpg";